import uploadsarticlesdomesticViolenceAttorneysSacramentoimagelawOfficeDeskSacramentoJpg from "$lib/data/generated/uploads/articles/domestic-violence-attorneys-sacramento/image/law-office-desk-sacramento.jpg";

export const uploads = {
  "uploads/articles/domestic-violence-attorneys-sacramento/image/law-office-desk-sacramento.jpg": uploadsarticlesdomesticViolenceAttorneysSacramentoimagelawOfficeDeskSacramentoJpg
};